
<section class="overview" :class="{ 'graph-only': graphOnly }">
  <section v-if="!graphOnly" class="left">
    <header v-if="date || title">
      <div class="date">
        {{ $filters.date(date) }}
      </div>

      <h4 class="secondary-font">{{ title }}</h4>
    </header>

    <div class="stats">
      <stat-item
        v-for="(stat, i) in stats"
        :key="i"
        :label="stat.label"
        :value="stat.value"
        :success="stat.positive"
        :error="stat.negative"
      />
    </div>
  </section>

  <graph
    v-bind="$attrs"
    v-on="$listeners"
    :zoom="zoom"
    :scale="scale"
    :labels="labels"
    :datasets="datasets"
  />
</section>
